import { useEffect, useRef } from 'react';
import { getSupabase, isSupabaseConfigured } from '../lib/supabase';
import { speak } from '../lib/voiceAnnounce';

/** 음성으로 읽어줄 알림 타입만 — 예약 확정("예약되었다는 음성") + 완료("마무리 음성") */
const VOICE_TYPES = new Set(['booking_confirmed', 'booking_completed']);

/**
 * 고객이 앱을 화면에 켜둔 상태에서 예약 확정/완료 알림(push_notifications insert)이 오면
 * 음성으로 읽어준다. 웹 특성상 백그라운드/앱종료 상태에서는 재생되지 않음 — 텍스트 알림
 * (푸시/알림함)은 이 훅과 무관하게 항상 정상적으로 감.
 * @param {string|null} appUserId public.users.id
 * @param {string} language 'ko'|'en'|'vi'|'ru'
 */
export function useBookingVoiceAnnouncements(appUserId, language) {
  const languageRef = useRef(language);
  languageRef.current = language;

  useEffect(() => {
    if (!isSupabaseConfigured || !appUserId) return undefined;
    const sb = getSupabase();
    if (!sb) return undefined;

    const channel = sb
      .channel(`voice-notif:${appUserId}`)
      .on(
        'postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'push_notifications', filter: `user_id=eq.${appUserId}` },
        (payload) => {
          const row = payload.new;
          if (!row || !VOICE_TYPES.has(row.type)) return;
          const text = [row.title, row.body].filter(Boolean).join('. ');
          if (text) speak(text, { lang: languageRef.current });
        },
      )
      .subscribe();

    return () => {
      void sb.removeChannel(channel);
    };
  }, [appUserId]);
}
